import { render } from "./expanderStep.vue?vue&type=template&id=45d0f9fb"
import script from "./expanderStep.vue?vue&type=script&lang=js"
export * from "./expanderStep.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__